import React, { memo, useEffect, useState } from "react";
import { Card, Row, Button } from "react-bootstrap";
import corner4 from 'assets/img/illustrations/corner-4.png';
import Background from "components/common/Background";
import { toast } from "react-toastify";
import { getStillageCollections } from "services/stillageCollections";
import DateSelect from "./DateSelect";
import CollectionsTable from "./CollectionsTable";
import PositionWidgetRow from "./positions/PositionWidgetRow";
import MarkAsCollected from "./edit-modals/MarkAsCollected";
import MarkAsNotCollected from "./edit-modals/MarkAsNotCollected";
import AddStillageToCollection from "./edit-modals/AddStillageToCollection";
import { StillageCollectionDataContext } from "context/Context";
import dayjs from "dayjs";
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

// Tomorrow, or the following Monday when tomorrow falls on a weekend.
const getNextCollectionDay = () => {
    const tomorrow = dayjs().add(1, 'day').startOf('day');
    return tomorrow.isoWeekday() > 5 ? tomorrow.add(1, 'week').startOf('isoWeek') : tomorrow;
};

const StillageCollection = () => {
    const [collectionDates, setCollectionDates] = useState({
        start: getNextCollectionDay().toISOString(),
        end: getNextCollectionDay().toISOString()
    });
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);

    const getCollectionData = async (start, end) => {
        setLoading(true);
        getStillageCollections(start, end)
            .then(res => setData(res))
            .catch((err) => {
                console.log(err);
                toast.error('Something went wrong! ', err?.message);
                setData([]);
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => getCollectionData(collectionDates.start, collectionDates.end), []);

    return (
        <StillageCollectionDataContext.Provider value={{ data, setData, getCollectionData, collectionDates }}>
            <Card className="w-100 p-4 mb-4">
                <Background image={corner4} className="bg-card" />
                <h4 className="text-600">Stillage Collections</h4>
                <p className='text-500'>Manage and view stillage collection data.</p>
            </Card>
            <PositionWidgetRow />
            <Card className="w-100 p-3 mb-4">
                <Card.Body className="position-relative">
                    <DateSelect
                        title='Collection Dates'
                        dates={collectionDates}
                        setDates={setCollectionDates}
                        clarifyingText='Collections are displayed with a default date of tomorrow.'>
                        <Button disabled={loading} type="button" variant="primary" onClick={() => getCollectionData(collectionDates.start, collectionDates.end)}>Search</Button>
                    </DateSelect>
                    <Row>
                        <CollectionsTable loading={loading} />
                    </Row>
                </Card.Body>
            </Card>
            <MarkAsCollected />
            <MarkAsNotCollected />
            <AddStillageToCollection />
        </StillageCollectionDataContext.Provider>
    );
}

export default memo(StillageCollection);